import { gateway } from '../../../gateway';

/**
 * Action to delete a kanban page
 * 
 * Backend endpoint: DELETE /kanban-pages/self/:pageUid
 * Response format: { status: 200, message: "Kanban page deleted", data: true }
 * Note: Backend automatically deletes all associated tasks (CASCADE)
 */
export const deleteKanbanPageAction = async (pageId: string): Promise<void> => {
  try {
    if (!pageId) {
      throw new Error('Page ID is required');
    }

    await gateway.delete(`/kanban-pages/self/${pageId}`);
    
    // Backend handles deletion and cascade to tasks automatically
    // No need to return anything, just ensure the request succeeded
  } catch (error: any) {
    console.error('Error deleting kanban page:', error);
    // Extract error message from backend response
    const errorMessage = error?.response?.data?.message || error?.message || 'Failed to delete kanban page';
    throw new Error(errorMessage);
  }
};

